import React, { useEffect, useState } from 'react';
import GlobalImage from '../imgComponent/index';
import styles from './index.module.less';

const PageTools = () => {
  const [show, setShow] = useState(false);
  const changeScrollTopShow = () => {
    setShow(window.pageYOffset < 400 ? false : true);
  }
  useEffect(() => {
    window.addEventListener('scroll', changeScrollTopShow);
    return () => {
      window.removeEventListener('scroll', changeScrollTopShow);
    }
  }, []);

  const handleScroll = () => {
    // eslint-disable-next-line no-use-before-define
    clearInterval(scrollToTop);
    var scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if ( pos > 0 ) {
        window.scrollTo( 0, pos - 20 );
      } else {
        window.clearInterval( scrollToTop );
      }
    }, 1);
  }

  return (
    <aside className={styles.tools}>
      {/* <a href="https://es3eflgtuw.feishu.cn/share/base/shrcnAIbJEtOTWgewqPfbJbEhue" target="_blank" rel="noreferrer">
      <div className={styles['box-wrap']}>
        <div className={`${styles['box_31']} flex-col`}>
          <div className={`${styles['block_3']} flex-col`}>
            <div className={`${styles['image-wrapper_14']} flex-col`}>
              <div className={styles['label_11']} />
            </div>
          </div>
        </div>
        <div className={`${styles['text-wrapper_10']} flex-col`}>
          <span className={styles['text_38']}>售前咨询</span>
        </div>
      </div>
      </a> */}
      <div className={styles.wrap}>
        <div className={`${styles['box_10']} flex-col`}>
          <div className={`${styles['group_1']} flex-col justify-between`}>
            <div className={styles['label_2']} />
            <span className={styles['text_10']}>使用咨询</span>
          </div>
        </div>
        <div className={`${styles['box_32']} flex-col`}>
          <div className={`${styles['group_10']} flex-col`}>
            <GlobalImage className={styles['block_4']} src="waiyanshe-service-min.jpeg" alt="图片" />
          </div>
          <span className={styles['text_39']}>扫描二维码咨询客服</span>
          <div className={`${styles['box_9']} flex-col`} />
        </div>
      </div>
      {show && (
        <div className={`${styles['box_12']} flex-col`} onClick={handleScroll}>
          <div className={`${styles['box_13']} flex-col justify-between`}>
            <div className={styles['label_3']} />
            <span className={styles['text_13']}>回到顶部</span>
          </div>
        </div>
      )}
    </aside>
  );
}

export default PageTools;
